<template>
  <form>
    <div class="row mb-2">
      <div class="col-sm-12">

        <div class="row mt-2">
          <label for="name" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.name") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`name`)">
              <input :class="parentProps.class" v-model="form.name" type="text" class="form-control " id="name">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="email" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.email") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`email`)">
              <input v-model="form.email" :class="parentProps.class" :readonly="!!form.id" type="text" class="form-control " id="email">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="appId" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.domain") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`appId`)">
              <Multiselect id="referralId"
                           class=""
                           :class="parentProps.class"
                           v-model="form.appId"
                           :options="store.getters['getAppsIds']"
                           :custom-label="(opt: any) => store.getters['getAppById'](opt)?.domain"
                           select-label="Select"
                           placeholder=""
                           open-direction="bottom"
                           :multiple="false"
                           :searchable="true"
                           :internal-search="true"
                           :clear-on-select="false"
                           :close-on-select="true"
                           :options-limit="100"
                           :limit="1000"
                           :show-no-results="false"
                           :hide-selected="false"
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="is_blocked" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.is_blocked") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input  v-model="form.isBlocked" class="form-check-input" type="checkbox" id="is_blocked">
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <label for="isManualWithdrawals" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isManualWithdrawals") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input  v-model="form.isManualWithdrawals" class="form-check-input" type="checkbox" id="isManualWithdrawals">
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <label for="isIpWhitelistEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.is_ip_whitelist_enabled") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input v-model="form.isIpWhitelistEnabled" class="form-check-input" type="checkbox" id="isIpWhitelistEnabled">
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="form.id">
          <div class="col-sm-4"></div>
          <div class="col-sm-8">
            <button type="button" class="btn btn-sm btn-outline-dark text-capitalize-first" @click.prevent="$emit('open-ip-whitelist')">
              {{ helper.trans('labels.merchant_ip_whitelist') }}
            </button>
          </div>
        </div>

        <div class="row mt-2" v-if="!form.id">
          <label for="createInvite" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.create_invite") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input  v-model="form.createInvite" class="form-check-input" type="checkbox" id="createInvite">
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="(form.id || form.createInvite === false) && store.getters.hasPermission(UserPermission.RESET_MERCHANT_PASSWORD)">
          <label for="password" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.password") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`password`)" >
              <div class="input-group" :class="parentProps.class">
                <input v-model="form.password" :class="parentProps.class" type="text" class="form-control " id="password">
                <button @click.prevent="form.password = helper.generatePassword()" type="button" class="btn btn-outline-secondary"><i class="fa fa-rotate"></i></button>
              </div>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="secret" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.secret") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`secret`)">
              <div class="input-group input-group-sm">
                <input readonly v-model="form.secret" :class="parentProps.class" type="text" class="form-control " id="secret">
                <button type="button" class="btn btn-outline-secondary" @click.prevent="form.secret = helper.generateRandomString(40)">
                  <i class="fa fa-rotate"></i>
                </button>
              </div>
            </FormInputWrapper>
          </div>
        </div>

        <div v-if="store.getters.isAdmin" class="">
          <div class="row mt-2">
            <label for="referralId" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.referral") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referralId`)">
                <Multiselect id="referralId"
                             class=""
                             :class="parentProps.class"
                             v-model="form.referral"
                             track-by="id"
                             :options="referrals"
                             :custom-label="(opt: any) => `${opt.name} (${opt.email})`"
                             :custom-value="(opt: any) => opt.id"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                             @search-change="asyncFindReferrals"
                             :loading="isReferralsSelectLoading"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="form.referral">
            <label for="referralPayInFee" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_in_reward_fee_percent") }}</label>
            <div class="col-sm-8 row">
              <div class="col-sm-3" >
                <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referralPayInFee`)">
                  <div :class="parentProps.class">
                <input v-model="form.referralPayInFee" type="text" class="form-control " id="referralPayInFee"
                       v-maska
                       data-maska="99.99"
                       data-maska-tokens="9:[0-9]:optional"
                       :class="parentProps.class"
                >
                  </div>
                </FormInputWrapper>
              </div>
              <div class="col-sm-3 ms-2">
                  <button @click.prevent="toggleRefPayInType(1)" class="btn btn-outline-secondary" type="button">{{ helper.trans(`labels.ref_fee_type.${form.referralPayInFeeType}`)}}</button>
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="form.referral">
            <label for="referralPayOutFee" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_out_reward_fee_percent") }}</label>
            <div class="col-sm-8 row ">
              <div class="col-sm-3 ">
                <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referralPayOutFee`)">
                  <div  :class="parentProps.class">
                    <input v-model="form.referralPayOutFee" type="text" class="form-control " id="referralPayOutFee"
                           v-maska
                           data-maska="99.99"
                           data-maska-tokens="9:[0-9]:optional"
                           :class="parentProps.class"
                    >
                  </div>
                </FormInputWrapper>
              </div>
              <div class="col-sm-3 ms-2">
                <button @click.prevent="toggleRefPayOutType(1)"  class="btn btn-outline-secondary" type="button">{{ helper.trans(`labels.ref_fee_type.${form.referralPayOutFeeType}`)}}</button>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <label for="referral2" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.referral") }} 2</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referral2`)">
                <Multiselect id="referral2"
                             class=""
                             :class="parentProps.class"
                             v-model="form.referral2"
                             track-by="id"
                             :options="referrals"
                             :custom-label="(opt: any) => `${opt.name} (${opt.email})`"
                             :custom-value="(opt: any) => opt.id"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                             @search-change="asyncFindReferrals"
                             :loading="isReferralsSelectLoading"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="form.referral2">
            <label for="referral2PayInFee" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_in_reward_fee_percent") }}</label>
            <div class="col-sm-8 row ">
                <div class="col-sm-3 ">
                  <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referral2PayInFee`)">
                    <div  :class="parentProps.class">
                      <input v-model="form.referral2PayInFee" type="text" class="form-control " id="referral2PayInFee"
                             v-maska
                             data-maska="99.99"
                             data-maska-tokens="9:[0-9]:optional"
                             :class="parentProps.class"
                      >
                    </div>
                  </FormInputWrapper>
                </div>
              <div class="col-sm-3 ms-2">
                <button @click.prevent="toggleRefPayInType(2)"  class="btn btn-outline-secondary" type="button">{{ helper.trans(`labels.ref_fee_type.${form.referral2PayInFeeType}`)}}</button>
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="form.referral2">
            <label for="referral2PayOutFee" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_out_reward_fee_percent") }}</label>
            <div class="col-sm-8 row ">
              <div class="col-sm-3 ">
                <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referral2PayOutFee`)">
                  <div  :class="parentProps.class">
                    <input v-model="form.referral2PayOutFee" type="text" class="form-control " id="referral2PayOutFee"
                           v-maska
                           data-maska="99.99"
                           data-maska-tokens="9:[0-9]:optional"
                           :class="parentProps.class"
                    >
                  </div>
                </FormInputWrapper>
              </div>
              <div class="col-sm-3 ms-2">
                <button @click.prevent="toggleRefPayOutType(2)"  class="btn btn-outline-secondary" type="button">{{ helper.trans(`labels.ref_fee_type.${form.referral2PayOutFeeType}`)}}</button>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <label for="referral3" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.referral") }} 3</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referral3`)">
                <Multiselect id="referral3"
                             class=""
                             :class="parentProps.class"
                             v-model="form.referral3"
                             track-by="id"
                             :options="referrals"
                             :custom-label="(opt: any) => `${opt.name} (${opt.email})`"
                             :custom-value="(opt: any) => opt.id"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                             @search-change="asyncFindReferrals"
                             :loading="isReferralsSelectLoading"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="form.referral3">
            <label for="referral3PayInFee" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_in_reward_fee_percent") }}</label>
            <div class="col-sm-8 row ">
              <div class="col-sm-3 ">
                <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referral3PayInFee`)">
                  <div  :class="parentProps.class">
                    <input v-model="form.referral3PayInFee" type="text" class="form-control " id="referral3PayInFee"
                           v-maska
                           data-maska="99.99"
                           data-maska-tokens="9:[0-9]:optional"
                           :class="parentProps.class"
                    >
                  </div>
                </FormInputWrapper>
              </div>
              <div class="col-sm-3 ms-2">
                <button @click.prevent="toggleRefPayInType(3)"  class="btn btn-outline-secondary" type="button">{{ helper.trans(`labels.ref_fee_type.${form.referral3PayInFeeType}`)}}</button>
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="form.referral3">
            <label for="referral3PayOutFee" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_out_reward_fee_percent") }}</label>
            <div class="col-sm-8 row ">
              <div class="col-sm-3 ">
                <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referral3PayOutFee`)">
                  <div  :class="parentProps.class">
                    <input v-model="form.referral3PayOutFee" type="text" class="form-control " id="referral3PayOutFee"
                           v-maska
                           data-maska="99.99"
                           data-maska-tokens="9:[0-9]:optional"
                           :class="parentProps.class"
                    >
                  </div>
                </FormInputWrapper>
              </div>
              <div class="col-sm-3 ms-2">
                <button @click.prevent="toggleRefPayOutType(3)"  class="btn btn-outline-secondary" type="button">{{ helper.trans(`labels.ref_fee_type.${form.referral3PayOutFeeType}`)}}</button>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <label for="referral4" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.referral") }} 4</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referral4`)">
                <Multiselect id="referral4"
                             class=""
                             :class="parentProps.class"
                             v-model="form.referral4"
                             track-by="id"
                             :options="referrals"
                             :custom-label="(opt: any) => `${opt.name} (${opt.email})`"
                             :custom-value="(opt: any) => opt.id"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                             @search-change="asyncFindReferrals"
                             :loading="isReferralsSelectLoading"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="form.referral4">
            <label for="referral4PayInFee" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_in_reward_fee_percent") }}</label>
            <div class="col-sm-8 row ">
              <div class="col-sm-3 ">
                <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referral4PayInFee`)">
                  <div  :class="parentProps.class">
                    <input v-model="form.referral4PayInFee" type="text" class="form-control " id="referral4PayInFee"
                           v-maska
                           data-maska="99.99"
                           data-maska-tokens="9:[0-9]:optional"
                           :class="parentProps.class"
                    >
                  </div>
                </FormInputWrapper>
              </div>
              <div class="col-sm-3 ms-2">
                <button @click.prevent="toggleRefPayInType(4)"  class="btn btn-outline-secondary" type="button">{{ helper.trans(`labels.ref_fee_type.${form.referral4PayInFeeType}`)}}</button>
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="form.referral4">
            <label for="referral4PayOutFee" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_out_reward_fee_percent") }}</label>
            <div class="col-sm-8 row ">
              <div class="col-sm-3 ">
                <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referral4PayOutFee`)">
                  <div  :class="parentProps.class">
                    <input v-model="form.referral4PayOutFee" type="text" class="form-control " id="referral4PayOutFee"
                           v-maska
                           data-maska="99.99"
                           data-maska-tokens="9:[0-9]:optional"
                           :class="parentProps.class"
                    >
                  </div>
                </FormInputWrapper>
              </div>
              <div class="col-sm-3 ms-2">
                <button @click.prevent="toggleRefPayOutType(4)"  class="btn btn-outline-secondary" type="button">{{ helper.trans(`labels.ref_fee_type.${form.referral4PayOutFeeType}`)}}</button>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <label for="referral5" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.referral") }} 5</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referral5`)">
                <Multiselect id="referral5"
                             class=""
                             :class="parentProps.class"
                             v-model="form.referral5"
                             track-by="id"
                             :options="referrals"
                             :custom-label="(opt: any) => `${opt.name} (${opt.email})`"
                             :custom-value="(opt: any) => opt.id"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                             @search-change="asyncFindReferrals"
                             :loading="isReferralsSelectLoading"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="form.referral5">
            <label for="referral5PayInFee" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_in_reward_fee_percent") }}</label>
            <div class="col-sm-8 row ">
              <div class="col-sm-3 ">
                <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referral5PayInFee`)">
                  <div  :class="parentProps.class">
                    <input v-model="form.referral5PayInFee" type="text" class="form-control " id="referral5PayInFee"
                           v-maska
                           data-maska="99.99"
                           data-maska-tokens="9:[0-9]:optional"
                           :class="parentProps.class"
                    >
                  </div>
                </FormInputWrapper>
              </div>
              <div class="col-sm-3 ms-2">
                <button @click.prevent="toggleRefPayInType(5)"  class="btn btn-outline-secondary" type="button">{{ helper.trans(`labels.ref_fee_type.${form.referral5PayInFeeType}`)}}</button>
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="form.referral5">
            <label for="referral5PayOutFee" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_out_reward_fee_percent") }}</label>
            <div class="col-sm-8 row ">
              <div class="col-sm-3 ">
                <FormInputWrapper v-slot="parentProps" :errors="getErrors(`referral5PayOutFee`)">
                  <div  :class="parentProps.class">
                    <input v-model="form.referral5PayOutFee" type="text" class="form-control " id="referral5PayOutFee"
                           v-maska
                           data-maska="99.99"
                           data-maska-tokens="9:[0-9]:optional"
                           :class="parentProps.class"
                    >
                  </div>
                </FormInputWrapper>
              </div>
              <div class="col-sm-3 ms-2">
                <button @click.prevent="toggleRefPayOutType(5)"  class="btn btn-outline-secondary" type="button">{{ helper.trans(`labels.ref_fee_type.${form.referral5PayOutFeeType}`)}}</button>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <label for="rateSource" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.rate_source") }}, in</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`rateSource`)">
                <Multiselect id="parentId"
                             class=""
                             :class="parentProps.class"
                             v-model="form.rateSource"
                             :options="store.getters['rateSources/all']"
                             :custom-label="(opt: any) => store.getters['rateSources/get'](opt)?.name"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2">
            <label for="payOutRateSource" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.rate_source") }}, out</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`payOutRateSource`)">
                <Multiselect id="parentId"
                             class=""
                             :class="parentProps.class"
                             v-model="form.payOutRateSource"
                             :options="store.getters['rateSources/all']"
                             :custom-label="(opt: any) => store.getters['rateSources/get'](opt)?.name"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2">
            <label for="traderPayInRateSource" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.trader_rate_source") }}, in</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`traderPayInRateSource`)">
                <Multiselect id="parentId"
                             class=""
                             :class="parentProps.class"
                             v-model="form.traderPayInRateSource"
                             :options="store.getters['rateSources/all']"
                             :custom-label="(opt: any) => store.getters['rateSources/get'](opt)?.name"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2">
            <label for="traderPayOutRateSource" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.trader_rate_source") }}, out</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`traderPayOutRateSource`)">
                <Multiselect id="parentId"
                             class=""
                             :class="parentProps.class"
                             v-model="form.traderPayOutRateSource"
                             :options="store.getters['rateSources/all']"
                             :custom-label="(opt: any) => store.getters['rateSources/get'](opt)?.name"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>


          <div class="row mt-2">
            <label for="tgChatGroupId" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.main_tg_group_id") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`tgChatGroupId`)">
                <input :class="parentProps.class" v-model="form.tgChatGroupId" type="text" class="form-control " id="tgChatGroupId">
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2">
            <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.receipt_forward_settings") }}</label>
            <div class="col-sm-8">
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm text-capitalize-first"
                @click.prevent="openReceiptForwardModal"
              >
                {{ helper.trans('labels.receipt_forward_configure') }}
              </button>
              <small class="text-muted d-block mt-1">{{ receiptForwardSummary }}</small>
            </div>
          </div>

          <div class="row mt-2">
            <label for="isAvailableWorkWithUnsafeTgGroup" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isAvailableWorkWithUnsafeTgGroup") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isAvailableWorkWithUnsafeTgGroup" class="form-check-input" type="checkbox" id="isAvailableWorkWithUnsafeTgGroup">
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.additional_groups") }}</label>
            <div class="col-sm-8">
              <div class="mb-2">
                <div v-for="(group, index) in form.tgGroups" :key="index" class="d-flex flex-row align-items-center gap-2 mb-2">
                  <input
                    v-model="group.tgGroupId"
                    type="text"
                    class="form-control"
                    :placeholder="helper.trans('labels.group_id_placeholder', {number: index + 1})"
                  >
                  <div class="form-check form-switch mb-0 flex-shrink-0">
                    <input
                      v-model="group.roles"
                      type="checkbox"
                      class="form-check-input"
                      :value="MerchantTgGroupRole.DISPUTE_CREATION"
                      :id="`tgGroupDisputeCreation${index}`"
                    >
                    <label
                      class="form-check-label text-nowrap"
                      :for="`tgGroupDisputeCreation${index}`"
                      v-b-tooltip.hover
                      :title="helper.trans('labels.tg_group_dispute_creation_role')"
                    >
                      {{ helper.trans('labels.tg_group_dispute_here') }}
                    </label>
                  </div>
                  <button
                    type="button"
                    @click="removeTgGroup(index)"
                    class="btn btn-outline-danger btn-sm flex-shrink-0"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
                <button
                  type="button"
                  @click="addTgGroup"
                  class="btn btn-outline-primary btn-sm"
                >
                  <i class="fa fa-plus"></i> {{ helper.trans("button.add_group") }}
                </button>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.turnover_report_settings") }}</label>
            <div class="col-sm-8"></div>
          </div>

          <div class="row mt-2">
            <label for="turnoverReportTgGroupId" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.turnover_report_tg_group_id") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`turnoverReportTgGroupId`)">
                <input :class="parentProps.class" v-model="form.turnoverReportTgGroupId" type="text" class="form-control " id="turnoverReportTgGroupId"
                       :placeholder="helper.trans('labels.turnover_report_tg_group_id_placeholder')">
              </FormInputWrapper>
              <small class="text-muted d-block mt-1">{{ helper.trans("labels.turnover_report_tg_group_id_hint") }}</small>
            </div>
          </div>

          <div class="row mt-2">
            <label for="turnoverReportSendHour" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.turnover_report_send_hour") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getTurnoverReportErrors(`turnoverReportSendHour`)">
                <select id="turnoverReportSendHour" v-model="form.turnoverReportSendHour" class="form-select" :class="parentProps.class">
                  <option :value="null"></option>
                  <option v-for="hour in 24" :key="hour - 1" :value="hour - 1">{{ hour - 1 }}</option>
                </select>
              </FormInputWrapper>
              <small class="text-muted d-block mt-1">{{ helper.trans("labels.turnover_report_send_hour_hint") }}</small>
            </div>
          </div>

          <div class="row mt-2">
            <label for="turnoverReportMiddayEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.turnover_report_midday_enabled") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.turnoverReportMiddayEnabled" class="form-check-input" type="checkbox" id="turnoverReportMiddayEnabled">
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.conversion_report_settings") }}</label>
            <div class="col-sm-8"></div>
          </div>

          <div class="row mt-2">
            <label for="conversionReportTgGroupId" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.conversion_report_tg_group_id") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`conversionReportTgGroupId`)">
                <input :class="parentProps.class" v-model="form.conversionReportTgGroupId" type="text" class="form-control " id="conversionReportTgGroupId"
                       :placeholder="helper.trans('labels.conversion_report_tg_group_id_placeholder')">
              </FormInputWrapper>
              <small class="text-muted d-block mt-1">{{ helper.trans("labels.conversion_report_tg_group_id_hint") }}</small>
            </div>
          </div>

          <div class="row mt-2">
            <label for="conversionReportSendHour" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.conversion_report_send_hour") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getConversionReportErrors(`conversionReportSendHour`)">
                <select id="conversionReportSendHour" v-model="form.conversionReportSendHour" class="form-select" :class="parentProps.class">
                  <option :value="null"></option>
                  <option v-for="hour in 24" :key="hour - 1" :value="hour - 1">{{ hour - 1 }}</option>
                </select>
              </FormInputWrapper>
              <small class="text-muted d-block mt-1">{{ helper.trans("labels.conversion_report_send_hour_hint") }}</small>
            </div>
          </div>

          <div class="row mt-2">
            <label for="conversionReportMiddayEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.conversion_report_midday_enabled") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.conversionReportMiddayEnabled" class="form-check-input" type="checkbox" id="conversionReportMiddayEnabled">
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <label for="conversionStatTgGroupId" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.conversion_stat_tg_group_id") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`conversionStatTgGroupId`)">
                <input :class="parentProps.class" v-model="form.conversionStatTgGroupId" type="text" class="form-control " id="conversionStatTgGroupId"
                       :placeholder="helper.trans('labels.conversion_stat_tg_group_id_placeholder')">
              </FormInputWrapper>
              <small class="text-muted d-block mt-1">{{ helper.trans("labels.conversion_stat_tg_group_id_hint") }}</small>
            </div>
          </div>

          <div class="row mt-2">
            <label for="isClientReceiptNotificationEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.receipt_site_to_merchant") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isClientReceiptNotificationEnabled" class="form-check-input" type="checkbox" id="isClientReceiptNotificationEnabled">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="dealCompletedNotifyFeatureEnabled">
            <label for="isDealCompletedNotificationEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.deal_completed_tg_notify_merchant") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.isDealCompletedNotificationEnabled" class="form-check-input" type="checkbox" id="isDealCompletedNotificationEnabled">
              </div>
              <small v-if="form.isDealCompletedNotificationEnabled && !form.tgChatGroupId" class="text-warning d-block mt-1">
                {{ helper.trans("labels.deal_completed_tg_notify_merchant_no_group_warning") }}
              </small>
            </div>
          </div>

          <div class="row mt-2" v-if="reuseMinCapFeatureEnabled">
            <label for="reuseMinCapEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.reuse_min_cap") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center mb-2">
                <input v-model="form.reuseMinCapEnabled" class="form-check-input" type="checkbox" id="reuseMinCapEnabled">
              </div>
              <FormInputWrapper v-slot="parentProps" :errors="getReuseMinCapErrors()">
                <CurrencyAmountMapInput v-model="form.reuseMinCaps" :disabled="!form.reuseMinCapEnabled" :class="parentProps.class"></CurrencyAmountMapInput>
              </FormInputWrapper>
              <small class="text-muted">{{ helper.trans("labels.reuse_min_cap_hint") }}</small>
            </div>
          </div>

          <div class="row mt-2">
            <label for="siteUploadForwardEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.receipt_site_to_trader") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="form.siteUploadForwardEnabled" class="form-check-input" type="checkbox" id="siteUploadForwardEnabled">
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <label for="isAntiFraudEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.anti_fraud_enabled") }}</label>
            <div class="col-sm-8">
              <div class="form-check form-switch d-flex align-items-center">
                <input v-model="isAntiFraudEnabled" class="form-check-input" type="checkbox" id="isAntiFraudEnabled">
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="isAntiFraudEnabled">
            <label for="antiFraudCancelDeal" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.anti_fraud_cancel_deal") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`antiFraudCancelDeal`)">
                <input :class="parentProps.class" v-model="form.antiFraudCancelDeal" type="number" min="1" class="form-control " id="antiFraudCancelDeal" placeholder="Количество сделок для срабатывания антифрода" @input="validatePositiveNumber">
              </FormInputWrapper>
            </div>
          </div>

          <div class="row mt-2" v-if="isAntiFraudEnabled">
            <label for="antiFraudCancelDealBannedSeconds" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.anti_fraud_cancel_deal_banned_seconds") }}</label>
            <div class="col-sm-8 row">
              <div class="col-sm-3">
                <FormInputWrapper v-slot="parentProps" :errors="getErrors(`antiFraudCancelDealBannedSeconds`)">
                  <input :class="parentProps.class" v-model="banHours" type="number" min="0" max="336" class="form-control " id="banHours" :placeholder="helper.trans('labels.hours')" @input="validateBanHours">
                </FormInputWrapper>
              </div>
              <div class="col-sm-3 ms-2">
                <FormInputWrapper v-slot="parentProps" :errors="getErrors(`antiFraudCancelDealBannedSeconds`)">
                  <input :class="parentProps.class" v-model="banMinutes" type="number" min="1" max="59" class="form-control " id="banMinutes" :placeholder="helper.trans('labels.minutes')" @input="validateBanMinutes">
                </FormInputWrapper>
              </div>
            </div>
          </div>

          <div class="row mt-2" v-if="form.id">
            <label for="2fa" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.2fa") }}</label>
            <div class="col-sm-8 align-items-center d-flex">
              <span v-if="form?.is2faEnabled" class="text-success">{{ helper.trans('labels.enabled')}}</span>
              <span v-if="!form?.is2faEnabled" class="text-warning"><i class="fa fa-warning"></i> {{ helper.trans('labels.disabled')}}</span>
              <button v-if="form?.is2faEnabled" type="button" class="btn btn-danger ms-2 btn-sm text-capitalize-first" @click.prevent="disable2fa(form.id)">{{ helper.trans("labels.disable")}}</button>
            </div>
          </div>

          <div class="row mt-3 mb-2" v-if="isAdmin && form.id">
            <div class="col-sm-12 d-flex justify-content-start">
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm text-capitalize-first"
                @click.prevent="$emit('open-settings-history')"
              >
                {{ helper.trans('labels.settings_history') }}
              </button>
            </div>
          </div>

        </div>

      </div>
    </div>
    <ConfirmModal ref="twoFaConfirmModal"></ConfirmModal>
    <MerchantReceiptForwardModal
      ref="receiptForwardModal"
      @apply="applyReceiptForwardSettings"
    ></MerchantReceiptForwardModal>
  </form>
</template>

<script lang="ts">
import {defineComponent, toRefs, reactive, computed, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import Multiselect from "vue-multiselect";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import APIClient from "@/service/APIClient";
import {useNotification} from "@kyvg/vue3-notification";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import MerchantFormDTO from "@/models/form/MerchantFormDTO";
import MerchantUpdateRequestDTO from "@/models/request/MerchantUpdateRequestDTO";
import MerchantCreateRequestDTO from "@/models/request/MerchantCreateRequestDTO";
import {MerchantTgGroupRole} from "@/models/enum/MerchantTgGroupRole";
import PaginationDTO from "@/models/PaginationDTO";
import {UserRole} from "@/models/enum/UserRole";
import {UserPermission} from "@/models/enum/UserPermission";
import UserDTO from "@/models/UserDTO";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";
import MerchantReceiptForwardModal from "@/components/MerchantReceiptForwardModal.vue";
import CurrencyAmountMapInput from "@/components/Form/CurrencyAmountMapInput.vue";
import {
  applyReceiptForwardModalSettingsToForm,
  applyReceiptForwardSettingsToForm,
  MerchantReceiptForwardModalSettings,
  MerchantReceiptForwardSettings,
  normalizeReceiptForwardModalSettings,
  normalizeReceiptForwardSettings,
  receiptForwardFieldPrefixes,
  serializeReceiptForwardComment,
  serializeReceiptForwardTargetChatIds,
} from "@/service/merchantReceiptForward";
import {ReceiptForwardMode} from "@/models/enum/ReceiptForwardMode";

const components = {
  Multiselect,
  FormInputWrapper,
  ConfirmModal,
  MerchantReceiptForwardModal,
  CurrencyAmountMapInput,
}

const api = new APIClient();
const notification = useNotification()

export default defineComponent({
  props: {},
  emits: ['open-ip-whitelist', 'open-settings-history'],
  components,
  setup() {
    const twoFaConfirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)
    const receiptForwardModal = ref<InstanceType<typeof MerchantReceiptForwardModal> | null>(null)
    const store = useStore();
    const state = reactive({
      errors: {} as ValidationErrorDTO[]|any,
      form: {} as MerchantFormDTO,
      isReferralsSelectLoading: false,
      referrals: [] as UserDTO[],
      isAntiFraudEnabled: false
    });

    const getReceiptForwardErrors = () => {
      const result: Record<string, ValidationErrorDTO[]> = {};
      for (const [path, fieldErrors] of Object.entries(state.errors)) {
        if (receiptForwardFieldPrefixes.some(prefix => path === prefix || path.startsWith(`${prefix}.`))) {
          result[path] = fieldErrors as ValidationErrorDTO[];
        }
      }
      return result;
    };

    const hasReceiptForwardErrors = () => Object.keys(getReceiptForwardErrors()).length > 0;

    const syncFormReceiptForwardSettings = (submittedForm: MerchantFormDTO) => {
      applyReceiptForwardSettingsToForm(
        state.form,
        {
          ...normalizeReceiptForwardSettings(submittedForm),
          receiptForwardComment: serializeReceiptForwardComment(submittedForm.receiptForwardComment),
          receiptForwardTargetChatIds: serializeReceiptForwardTargetChatIds(submittedForm.receiptForwardTargetChatIds),
        },
      );
    };

    const setErrors = (data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(error.field)) {
          state.errors[error.field] = [];
        }
        state.errors[error.field].push(error)
      }
    }

    const parseTurnoverReportHour = (value: number | string | null | undefined): number | null => {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      const hour = Number(value);
      return Number.isInteger(hour) && hour >= 0 && hour <= 23 ? hour : null;
    };

    const validateTurnoverReport = (form: MerchantFormDTO): ValidationErrorDTO[] => {
      if (!(form.turnoverReportTgGroupId ?? '').trim()) {
        return [];
      }
      if (parseTurnoverReportHour(form.turnoverReportSendHour) === null) {
        return [{field: 'turnoverReportSendHour', code: 'INVALID_VALUE', message: helper.trans('server_errors.INVALID_VALUE')}];
      }
      return [];
    };

    const validateConversionReport = (form: MerchantFormDTO): ValidationErrorDTO[] => {
      if (!(form.conversionReportTgGroupId ?? '').trim()) {
        return [];
      }
      if (parseTurnoverReportHour(form.conversionReportSendHour) === null) {
        return [{field: 'conversionReportSendHour', code: 'INVALID_VALUE', message: helper.trans('server_errors.INVALID_VALUE')}];
      }
      return [];
    };

    const reuseMinCapFeatureEnabled = computed<boolean>(() => {
      return !!store.getters.isAdmin && !!store.getters.getAppData?.REQUISITES_REUSE_MIN_SUM_CAP_ENABLED
    })

    const dealCompletedNotifyFeatureEnabled = computed<boolean>(() => {
      return !!store.getters.isAdmin && !!store.getters.getAppData?.MERCHANT_DEAL_COMPLETED_TG_NOTIFY_ENABLED
    })

    const getReuseMinCapErrors = (): ValidationErrorDTO[] => {
      const result: ValidationErrorDTO[] = [];
      for (const [path, fieldErrors] of Object.entries(state.errors)) {
        if (path === 'reuseMinCaps' || path.startsWith('reuseMinCaps[')) {
          result.push(...(fieldErrors as ValidationErrorDTO[]));
        }
      }

      return result;
    }

    const save = (): Promise<any> => {
      setErrors([]);
      const form = getForm();
      const turnoverReportErrors = validateTurnoverReport(form);
      const conversionReportErrors = validateConversionReport(form);
      if (turnoverReportErrors.length || conversionReportErrors.length) {
        return Promise.reject([...turnoverReportErrors, ...conversionReportErrors]);
      }

      let promise;

      const formData = {
        ...form,
        referralId: form.referral?.id,
        referralPayInFee: form.referralPayInFee ? helper.percentToFloat(form.referralPayInFee) : null,
        referralPayOutFee: form.referralPayOutFee ? helper.percentToFloat(form.referralPayOutFee) : null,
        referral2Id: form.referral2?.id,
        referral2PayInFee: form.referral2PayInFee ? helper.percentToFloat(form.referral2PayInFee) : null,
        referral2PayOutFee: form.referral2PayOutFee ? helper.percentToFloat(form.referral2PayOutFee) : null,
        referral3Id: form.referral3?.id,
        referral3PayInFee: form.referral3PayInFee ? helper.percentToFloat(form.referral3PayInFee) : null,
        referral3PayOutFee: form.referral3PayOutFee ? helper.percentToFloat(form.referral3PayOutFee) : null,
        referral4Id: form.referral4?.id,
        referral4PayInFee: form.referral4PayInFee ? helper.percentToFloat(form.referral4PayInFee) : null,
        referral4PayOutFee: form.referral4PayOutFee ? helper.percentToFloat(form.referral4PayOutFee) : null,
        referral5Id: form.referral5?.id,
        referral5PayInFee: form.referral5PayInFee ? helper.percentToFloat(form.referral5PayInFee) : null,
        referral5PayOutFee: form.referral5PayOutFee ? helper.percentToFloat(form.referral5PayOutFee) : null,
        antiFraudCancelDeal: form.antiFraudCancelDeal || null,
        antiFraudCancelDealBannedSeconds: form.antiFraudCancelDealBannedSeconds || null,
        tgGroups: form.tgGroups?.filter(group => group.tgGroupId.trim() !== '').map(({ tgGroupId, roles }) => ({ tgGroupId, roles: roles ?? [] })) || [],
        isAvailableWorkWithUnsafeTgGroup: form.isAvailableWorkWithUnsafeTgGroup,
        tgReceiptForwardGroupId: form.tgReceiptForwardGroupId ?? null,
        tgReceiptActionsGroupId: form.tgReceiptActionsGroupId ?? null,
        receiptForwardMode: form.receiptForwardMode ?? ReceiptForwardMode.FULL,
        receiptForwardComment: serializeReceiptForwardComment(form.receiptForwardComment),
        receiptForwardTargetChatIds: serializeReceiptForwardTargetChatIds(form.receiptForwardTargetChatIds),
        receiptForwardActions: [...(form.receiptForwardActions ?? [])],
        siteUploadForwardEnabled: form.siteUploadForwardEnabled ?? false,
        turnoverReportTgGroupId: (form.turnoverReportTgGroupId ?? '').trim(),
        turnoverReportSendHour: parseTurnoverReportHour(form.turnoverReportSendHour),
        turnoverReportMiddayEnabled: form.turnoverReportMiddayEnabled === true,
        conversionReportTgGroupId: (form.conversionReportTgGroupId ?? '').trim(),
        conversionStatTgGroupId: (form.conversionStatTgGroupId ?? '').trim(),
        conversionReportSendHour: parseTurnoverReportHour(form.conversionReportSendHour),
        conversionReportMiddayEnabled: form.conversionReportMiddayEnabled === true,
      } as Record<string, any>

      if (reuseMinCapFeatureEnabled.value) {
        formData.reuseMinCapEnabled = form.reuseMinCapEnabled === true;
        formData.reuseMinCaps = form.reuseMinCaps ?? {};
      } else {
        delete formData.reuseMinCapEnabled;
        delete formData.reuseMinCaps;
      }

      if (!dealCompletedNotifyFeatureEnabled.value) {
        delete formData.isDealCompletedNotificationEnabled;
      }

      if (form.id) {
        if (store.getters.isOperator) {
          promise = (form.password ? api.merchantsChangePassword(form.id, form.password) : Promise.resolve())
            .then((resp) => {
              notification.notify({title: helper.trans('merchants.notice.updated')});
              return resp;
            });
        } else {
          const data = {
            ...formData,
            password: form.password ? form.password : null,
          } as MerchantUpdateRequestDTO;

          promise = api.merchantsUpdate(form.id, data)
            .then((resp) => {
              notification.notify({title: helper.trans('merchants.notice.updated')});
              syncFormReceiptForwardSettings(form);

              return resp;
            })
        }
      } else {
        const data = {
          ...formData,
          password: form.createInvite ? null : (form.password ? form.password : null),
          createInvite: form.createInvite
        } as MerchantCreateRequestDTO;

        promise = api.merchantsCreate(data)
          .then((resp) => {
            notification.notify({title: helper.trans('merchants.notice.created')});
            syncFormReceiptForwardSettings(form);

            return resp;
          })
      }

      promise
        .catch((e: any) => {
          if (e.response && e.request && e.request.status === 400 && e.response.data) {
            setErrors(e.response.data)
            if (hasReceiptForwardErrors()) {
              openReceiptForwardModal();
            }
          } else {
            console.log(e);
          }

        })

      return promise
    }

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    const getTurnoverReportErrors = (path: string) => {
      const liveErrors = validateTurnoverReport(state.form).filter((error) => error.field === path);
      if (liveErrors.length) {
        return liveErrors;
      }

      return getErrors(path);
    }

    const getConversionReportErrors = (path: string) => {
      const liveErrors = validateConversionReport(state.form).filter((error) => error.field === path);
      if (liveErrors.length) {
        return liveErrors;
      }

      return getErrors(path);
    }

    const hasErrors = (path: string) => {
      return state.errors[path]?.length > 0
    }

    const getForm = (): MerchantFormDTO => {
      return state.form
    }

    const setForm = (form: MerchantFormDTO) => {
      state.errors = {}
      const receiptForwardSettings = normalizeReceiptForwardSettings(form);
      state.form = {
        ...form,
        ...receiptForwardSettings,
        tgGroups: (form.tgGroups ?? []).map(group => ({
          tgGroupId: group.tgGroupId,
          roles: group.roles ?? []
        })),
        turnoverReportSendHour: parseTurnoverReportHour(form.turnoverReportSendHour),
        turnoverReportMiddayEnabled: form.turnoverReportMiddayEnabled === true,
        conversionReportSendHour: parseTurnoverReportHour(form.conversionReportSendHour),
        conversionReportMiddayEnabled: form.conversionReportMiddayEnabled === true,
        reuseMinCapEnabled: form.reuseMinCapEnabled === true,
        reuseMinCaps: Array.isArray(form.reuseMinCaps) ? {} : {...(form.reuseMinCaps ?? {})},
      }
      state.isAntiFraudEnabled = !!(form.antiFraudCancelDeal || form.antiFraudCancelDealBannedSeconds);
    }

    const toggleRefPayInType = (num: number) => {
      type AllowedFields = 'referralPayInFeeType' | 'referral2PayInFeeType' | 'referral3PayInFeeType' | 'referral4PayInFeeType' | 'referral5PayInFeeType'
      const field: AllowedFields = num === 1 ? 'referralPayInFeeType' : `referral${num}PayInFeeType` as AllowedFields

      if (state.form[field] === 0) {
        state.form[field] = 1
      } else {
        state.form[field] = 0
      }
    }

    const toggleRefPayOutType = (num: number) => {
      type AllowedFields = 'referralPayOutFeeType' | 'referral2PayOutFeeType' | 'referral3PayOutFeeType' | 'referral4PayOutFeeType' | 'referral5PayOutFeeType'
      const field: AllowedFields = num === 1 ? 'referralPayOutFeeType' : `referral${num}PayOutFeeType` as AllowedFields
      if (state.form[field] === 0) {
        state.form[field] = 1
      } else {
        state.form[field] = 0
      }
    }

    const asyncFindReferrals = async (query: string) => {
      state.isReferralsSelectLoading = true;
      state.referrals = (await api.users({limit: 100, offset: 0} as PaginationDTO, {query: query, roles: [UserRole.REFERRAL]})).items;
      state.isReferralsSelectLoading = false
    }

    onMounted(() => {
      asyncFindReferrals('')
      store.dispatch('loadApps')
    })

    watch(() => state.isAntiFraudEnabled, (newValue) => {
      if (!newValue) {
        state.form.antiFraudCancelDeal = null;
        state.form.antiFraudCancelDealBannedSeconds = null;
      } else {
          if (!state.form.antiFraudCancelDeal) {
            state.form.antiFraudCancelDeal = 1;
          }
          if (!state.form.antiFraudCancelDealBannedSeconds) {
            state.form.antiFraudCancelDealBannedSeconds = 60;
          }
        }
    });

    const isAntiFraudEnabled = computed({
      get: () => {
        return state.isAntiFraudEnabled || !!(state.form.antiFraudCancelDeal || state.form.antiFraudCancelDealBannedSeconds);
      },
      set: (value: boolean) => {
        state.isAntiFraudEnabled = value;
      }
    });

    const banHours = computed({
      get: () => {
        if (!state.form.antiFraudCancelDealBannedSeconds) return '';
        return Math.floor(state.form.antiFraudCancelDealBannedSeconds / 3600);
      },
      set: (value: number) => {
        if (value >= 0 && value <= 336) {
          const currentMinutes = state.form.antiFraudCancelDealBannedSeconds ? Math.floor((state.form.antiFraudCancelDealBannedSeconds % 3600) / 60) : 1;
          state.form.antiFraudCancelDealBannedSeconds = value * 3600 + currentMinutes * 60;
        }
      }
    });

    const banMinutes = computed({
      get: () => {
        if (!state.form.antiFraudCancelDealBannedSeconds) return '';
        const minutes = Math.floor((state.form.antiFraudCancelDealBannedSeconds % 3600) / 60);
        return minutes === 0 ? 1 : minutes;
      },
      set: (value: number) => {
        if (value >= 1 && value <= 59) {
          const currentHours = state.form.antiFraudCancelDealBannedSeconds ? Math.floor(state.form.antiFraudCancelDealBannedSeconds / 3600) : 1;
          state.form.antiFraudCancelDealBannedSeconds = currentHours * 3600 + value * 60;
        }
      }
    });

    const validatePositiveNumber = (event: Event) => {
      const target = event.target as HTMLInputElement;
      const value = parseInt(target.value);
      if (value < 1) {
        target.value = '1';
        state.form.antiFraudCancelDeal = 1;
      }
    };

    const validateBanHours = (event: Event) => {
      const target = event.target as HTMLInputElement;
      const value = parseInt(target.value);
      if (value < 0) {
        target.value = '0';
        banHours.value = 0;
      } else if (value > 336) {
        target.value = '336';
        banHours.value = 336;
      }
    };

    const validateBanMinutes = (event: Event) => {
      const target = event.target as HTMLInputElement;
      const value = parseInt(target.value);
      if (value < 1) {
        target.value = '1';
        banMinutes.value = 1;
      } else if (value > 59) {
        const currentHours = banHours.value || 1;
        const additionalHours = Math.floor(value / 60);
        const remainingMinutes = value % 60;
        
        const newHours = currentHours + additionalHours;
        if (newHours <= 336) {
          banHours.value = newHours;
          banMinutes.value = remainingMinutes === 0 ? 1 : remainingMinutes;
        } else {
          banHours.value = 336;
          banMinutes.value = 1;
        }
      }
    };
    const disable2fa = async (id: number) => {
      twoFaConfirmModal.value?.show({
        title: helper.trans('labels.2fa_disable_confirmation'),
        okTitle: null,
        cancelTitle: null,
        onOkClick: async () => {
          try {
            await api.user2faDisable(id);
            notification.notify({title: helper.trans('labels.2fa_disabled')});
            state.form.is2faEnabled = false
          } finally {
          }
        }
      } as ConfirmModalProps);
    }

    const addTgGroup = () => {
      if (!state.form.tgGroups) {
        state.form.tgGroups = [];
      }
      state.form.tgGroups.push({ tgGroupId: '', roles: [] });
    }

    const removeTgGroup = (index: number) => {
      if (state.form.tgGroups && state.form.tgGroups.length > index) {
        state.form.tgGroups.splice(index, 1);
      }
    }

    const openReceiptForwardModal = () => {
      receiptForwardModal.value?.show(
        normalizeReceiptForwardModalSettings(state.form),
        getReceiptForwardErrors(),
      );
    };

    const applyReceiptForwardSettings = (settings: MerchantReceiptForwardModalSettings) => {
      applyReceiptForwardModalSettingsToForm(state.form, settings);
    };

    const receiptForwardSummary = computed(() => {
      const settings = normalizeReceiptForwardSettings(state.form);
      const modeLabel = helper.trans(`labels.receipt_forward_mode_${settings.receiptForwardMode}`);
      const targetChatsCount = serializeReceiptForwardTargetChatIds(settings.receiptForwardTargetChatIds).length;
      const parts = [modeLabel];

      if (settings.tgReceiptForwardGroupId?.trim()) {
        parts.push(helper.trans('labels.receipt_forward_summary_source_configured'));
      }

      if (targetChatsCount > 0) {
        parts.push(helper.trans('labels.receipt_forward_summary_target_chats', {count: targetChatsCount}));
      }

      if (settings.receiptForwardComment?.trim()) {
        parts.push(helper.trans('labels.receipt_forward_summary_comment_enabled'));
      }

      if (settings.tgReceiptActionsGroupId?.trim()) {
        parts.push(helper.trans('labels.receipt_forward_summary_interactive_configured'));
      }

      return parts.join(' · ');
    });

    const isAdmin = computed<boolean>(() => store.getters.isAdmin)

    return {
      ...toRefs(state),
      getForm,
      setForm,
      store,
      isAdmin,
      reuseMinCapFeatureEnabled,
      dealCompletedNotifyFeatureEnabled,
      getReuseMinCapErrors,
      UserPermission,
      helper,
      numberFormatter,
      asyncFindReferrals,
      setErrors,
      getErrors,
      getTurnoverReportErrors,
      getConversionReportErrors,
      hasErrors,
      save,
      toggleRefPayOutType,
      toggleRefPayInType,
      disable2fa,
      twoFaConfirmModal,
      isAntiFraudEnabled,
      banHours,
      banMinutes,
      validatePositiveNumber,
      validateBanHours,
      validateBanMinutes,
      addTgGroup,
      removeTgGroup,
      MerchantTgGroupRole,
      receiptForwardModal,
      openReceiptForwardModal,
      applyReceiptForwardSettings,
      receiptForwardSummary,
    }
  }
})
</script>
